export function assertNonNullish<TValue>(value: TValue, message?: string): asserts value is NonNullable<TValue> {
	if (value === null || value === undefined) {
		throw Error(message || 'Assertion failed: value is null or undefined');
	}
}

export function assertString(value: unknown, message?: string): asserts value is string {
	if (typeof value !== 'string') {
		throw new TypeError(`${message ? message + '. ' : ''}Expected 'string', got: '${typeof value}'`);
	}
}

export function assertNumber(value: unknown, message?: string): asserts value is number {
	if (typeof value !== 'number') {
		throw new TypeError(`${message ? message + '. ' : ''}Expected 'number', got: '${typeof value}'`);
	}
}
